const MAX_MENUS_PER_RERUN_TIME_SLOT = 200

export default MAX_MENUS_PER_RERUN_TIME_SLOT
